export default __webpack_public_path__ + "static/media/Gail Pellerin.33f95a4b.jpg";